import { db } from "@/lib/firebase";
import { doc, updateDoc, increment, setDoc } from "firebase/firestore";

const COUNTERS_DOC = doc(db, "counters", "siteStats");

export async function incrementCounter(key: string, by = 1) {
  try {
    // Try to update existing counters doc
    await updateDoc(COUNTERS_DOC, { [key]: increment(by) });
  } catch (err) {
    // If doc does not exist, create it with the initial value
    try {
      await setDoc(COUNTERS_DOC, { [key]: by }, { merge: true });
    } catch (e) {
      console.warn("Failed to increment counter", key, e);
    }
  }
}

export async function getCountersDoc() {
  return COUNTERS_DOC;
}
